
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-magazines",
      function () {
        return require("private-next-pages/news-and-magazines.js");
      }
    ]);
  